import React from 'react';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../../../../CommonUtils/formatNumber';

interface Props {
  title?: string;
  value: number;
  isGainLoss?: boolean;
  size?: 'regular' | 'large';
}

export const Label = ({ title, value, isGainLoss, size }: Props) => {
  return (
    <Box>
      {title && <Text variant="smallCaps">{title}</Text>}

      <Text
        variant="tabular"
        fontSize={size === 'large' ? 'h2' : 'h2'}
        fontWeight={500}
        color={isGainLoss ? (value < 0 ? 'orange.500' : 'success.500') : 'neutral.700'}
      >
        {formatCurrency(value)}
      </Text>
    </Box>
  );
};
